import Splide from '@splidejs/splide';

import '@splidejs/splide/dist/css/splide-core.min.css';

document.addEventListener( 'DOMContentLoaded', function () {
    if(document.querySelector('.splide-product-thumbnails')) {
        var secondarySlider = new Splide( '.splide-product-thumbnails', {
            fixedWidth  : 100,
            height      : 60,
            gap         : 10,
            cover       : true,
            isNavigation: true,
            pagination : false,
            arrows     : true,
            focus       : 'center',
            rewind: true,
            breakpoints : {
                '600': {
                    fixedWidth: 66,
                    height    : 40,
                }
            },
            classes: {
                prev  : 'splide__arrow--prev icon icon-left',
                next  : 'splide__arrow--next icon icon-right',
            }
        } ).mount();
    }

    if(document.querySelector('.splide-product')) {
        var primarySlider = new Splide( '.splide-product', {
            type       : 'slide',
            pagination : false,
            arrows     : true,
            cover      : true,
            rewind: true,
            classes: {
                prev  : 'splide__arrow--prev icon icon-left',
                next  : 'splide__arrow--next icon icon-right',
            }
        } );
    }
    if(primarySlider && secondarySlider) {
        primarySlider.sync( secondarySlider ).mount();
    }
} );
